export default __webpack_public_path__ + "static/media/alumni_qr.99b03d35.jpg";